"use client";

import { c as _c } from "react/compiler-runtime";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useRouter } from "next/navigation";
import { fevicolInhomzRootRoute } from "../../../../_constants/tempRootRoute";
import ProgressiveImage from "../../../../_components/global/ProgressiveImage";
import { inhomzEvents } from "../../../../_lib/events";
import { useInhomzTrack } from "../../../../_hooks/useInhomzTrack";
export default function DesignIdeaHero(t0) {
  const $ = _c(14);
  const {
    category,
    image,
    title
  } = t0;
  const router = useRouter();
  const track = useInhomzTrack();
  let t1;
  if ($[0] !== category || $[1] !== router || $[2] !== track) {
    t1 = () => {
      track(inhomzEvents.designDetail.BACK_CLICKED, {
        category
      });
      router.push(`${fevicolInhomzRootRoute}/design-ideas/${category}`);
    };
    $[0] = category;
    $[1] = router;
    $[2] = track;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleBack = t1;
  const t2 = `${title} design idea`;
  let t3;
  if ($[4] !== image.src || $[5] !== t2) {
    t3 = <ProgressiveImage src={image.src} alt={t2} priority={true} className="object-cover" sizes="(min-width: 1024px) 60vw, 100vw" />;
    $[4] = image.src;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      backgroundColor: "var(--colorSurfaceSurface)",
      "&:hover": {
        backgroundColor: "var(--colorSurfaceSurface)",
        opacity: 0.9
      }
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ArrowBackIcon sx={{
      color: "var(--textPrimaryPrimary)"
    }} />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleBack) {
    t6 = <IconButton onClick={handleBack} aria-label="Go back" sx={t4} className="absolute left-4 top-4">{t5}</IconButton>;
    $[9] = handleBack;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <div className="relative aspect-[4/3] rounded-3xl overflow-hidden w-full bg-[--colorSurfaceSurfaceVar] sm:aspect-[16/9] md:aspect-[21/9] lg:aspect-[4/3]">{t3}{t6}</div>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}